import { lazy } from "react";
import { RouteSuspense } from "@/shared/routing/RouteSuspense";
import type { RouteObject } from "react-router-dom";

const InvitePage = lazy(() => import("./pages/InvitePage").then(module => ({ default: module.InvitePage })));

export const inviteRoutes: RouteObject[] = [
  {
    path: "invite/:token",
    element: <RouteSuspense><InvitePage /></RouteSuspense>,
  },
];
